import React from 'react'
import { Typography, makeStyles, Slider } from '@paintscout/ui'
import type { MuiTheme as Theme, SliderProps, StyleClasses } from '@paintscout/ui'

const useStyles = makeStyles<Theme, SliderOptionProps>(
  (theme) => ({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    sliderRoot: {
      marginLeft: theme.spacing(3),
      color: theme.palette.grey[800]
    },
    label: {
      flexShrink: 0,
      color: theme.palette.grey[800]
    }
  }),
  { name: 'SliderOption' }
)

export interface SliderOptionProps {
  classes?: StyleClasses<typeof useStyles>
  marks: SliderProps['marks']
  label: string
  value: number
  min: number
  max: number
  onChange: (value: number) => void
}

function SliderOption(props: SliderOptionProps) {
  const classes = useStyles(props)
  const { marks, label, value, min, max, onChange } = props

  const handleChange: any = (event: React.ChangeEvent<HTMLSpanElement>, value: number) => {
    onChange(value)
  }

  return (
    <div className={classes.root}>
      <Typography className={classes.label} variant={'h5'}>
        {label}
      </Typography>
      <Slider
        onMouseDown={(event) => event.stopPropagation()}
        classes={{ root: classes.sliderRoot }}
        defaultValue={value}
        marks={marks}
        max={max}
        min={min}
        onChange={handleChange}
        step={null}
        track={false}
      />
    </div>
  )
}

export default SliderOption
